// One publication list for React, static HTML, sitemap generation, and checks.
// Retain unfinished source records as drafts; never silently publish empty pages.
const posts = require('./posts.json');
const published = posts.filter(post => post.status !== 'draft');
for (const post of published) {
  if (post.status && post.status !== 'published') throw new Error(`Unknown post status: ${post.slug}`);
  if (!Array.isArray(post.body) || !post.body.length ||
      !post.body.some(block => block.type === 'p' && typeof block.text === 'string' && block.text.trim()) ||
      !post.excerpt?.trim() || /^placeholder$/i.test(post.excerpt.trim())) {
    throw new Error(`Incomplete published article: ${post.slug}. Complete its content or mark it draft.`);
  }
}
module.exports = published;
